import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  PageHeader,
  Form,
  Row,
  Col,
  Popconfirm,
  message,
} from "antd";
import Page from "_components/Page";
import { companyCategoryService } from "_services";

function Add({ history }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [form] = Form.useForm();

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        companyCategoryService
          .create(values)
          .then(() => {
            message.success("Successfully created!");
            history.push("/company-categories");
          })
          .catch((error) => {
            throw error;
          });
      })
      .catch((error) => {
        setError(`${error.message ?? "Please fix errors"}`);
      })
      .finally(() => {
        setIsLoading(false);
        setError();
      });
  };

  const onCancel = () => {
    history.push("/company-categories");
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/company-categories">Company Categories</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/company-categories/add">New Company Category</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={[
        <Popconfirm
          title="Are you sure to add the changes?"
          onConfirm={handleFormSubmit}
          key="add-confirm"
        >
          <Button key="1" type="primary" htmlType="submit" loading={isLoading}>
            Save
          </Button>
        </Popconfirm>,
        <Button key="2" htmlType="button" onClick={onCancel}>
          Cancel
        </Button>,
      ]}
    >
      <Page inner error={error}>
        <Form
          layout="vertical"
          form={form}
          name="form-create"
          requiredMark={false}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name={"code"}
                label="Code"
                rules={[{ required: true, message: "Code is required" }]}
              >
                <Input placeholder="Enter company category name" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name={"name"}
                label="Name"
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input placeholder="Enter category name" />
              </Form.Item>
            </Col>
            <Col span={8}></Col>
          </Row>
        </Form>
      </Page>
    </PageHeader>
  );
}

export default Add;
